import FormContentCreateOrEditCreatorPaymentMethod from './formContentCreateOrEditCreatorPaymentMethod';
import FormContentCreateOrEditCreatorLinks from './FormContentCreateOrEditCreatorLinks';
import { ControlledInput, ControlledSelect } from '@/components/controlled';
import { LabelRequired } from '@/components/hoc';
import { useFormContext } from 'react-hook-form';
import { getSelectOptions } from '@/functions';
import { TProps } from '.';

const FormContentCreateOrEditCreator = ({ fieldNames, requireReferralCode = false, readonly = false }: TProps) => {

  const { control } = useFormContext();

  return (
    <div className='space-y-4'>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Nom
        </LabelRequired>
        <ControlledInput
          disabled={readonly}
          control={control}
          rules={{ required: 'Requis' }}
          name={fieldNames.username}
          placeholder={'Nom du créateur'} />
      </div>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Type
        </LabelRequired>
        <ControlledSelect
          disabled={readonly}
          control={control}
          rules={{ required: 'Requis' }}
          name={fieldNames.type}
          placeholder='Selectionner le type'
          options={getSelectOptions('CreatorTypeEnum')} />
      </div>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Sexe
        </LabelRequired>
        <ControlledSelect
          disabled={readonly}
          control={control}
          rules={{ required: 'Requis' }}
          name={fieldNames.gender}
          placeholder='Selectionner le genre'
          options={getSelectOptions('GenderEnum')} />
      </div>
      <div className='flex flex-col gap-2'>
        <LabelRequired required={requireReferralCode}>
          Code promo
        </LabelRequired>
        <ControlledInput
          disabled={readonly}
          control={control}
          minLength={6}
          maxLength={6}
          rules={{
            required: requireReferralCode ? 'Requis' : undefined,
            minLength: 6,
            maxLength: 6,
          }}
          name={fieldNames.referralCode}
          placeholder={'Code promo à 6 caractères'} />
      </div>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Pièces offertes
        </LabelRequired>
        <ControlledInput
          disabled={readonly}
          control={control}
          type='number'
          rules={{
            required: 'Requis',
            min: { value: 1, message: 'Minimum 1 pièce' },
          }}
          name={fieldNames.coinsAmount}
          placeholder={'Nombre de pièces offertes'} />
      </div>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Méthode de paiement
        </LabelRequired>
        <ControlledSelect
          disabled={readonly}
          control={control}
          rules={{ required: 'Requis' }}
          name={fieldNames.paymentInfo.method}
          placeholder='Selectionner une méthode'
          options={getSelectOptions('PaymentMethodEnum')} />
      </div>
      <FormContentCreateOrEditCreatorPaymentMethod
        fieldNames={fieldNames}
        readonly={readonly} />
      <FormContentCreateOrEditCreatorLinks
        fieldNames={fieldNames}
        readonly={readonly} />
    </div>
  );

};

export default FormContentCreateOrEditCreator;
